import { createReducer, on } from '@ngrx/store';

import { InsurancePackage } from '../models/insurance-package.interface';
import { addInsurancePackage, deleteInsurancePackage, setInsurancePackages, updateInsurancePackage } from './insurance-packages.actions';

export interface InsurancePackagesState {
  insurancePackages: InsurancePackage[];
}

const initialState: InsurancePackagesState = {
  insurancePackages: [],
};

export const insurancePackagesReducer = createReducer(
  initialState,
  on(setInsurancePackages, (state, { insurancePackages }) => ({ ...state, insurancePackages })),
  on(updateInsurancePackage, (state, { insurancePackage }) => ({
    ...state,
    insurancePackages: state.insurancePackages.map(pkg => (pkg.id === insurancePackage.id ? insurancePackage : pkg)),
  })),
  on(deleteInsurancePackage, (state, { id }) => ({
    ...state,
    insurancePackages: state.insurancePackages.filter(pkg => pkg.id !== id),
  })),
  on(addInsurancePackage, (state, { insurancePackage }) => ({
    ...state,
    insurancePackages: [...state.insurancePackages, insurancePackage],
  }))
);
